import { cn as e } from "../../shared/utils.js";
import { useTranslation as t } from "../../i18n/hooks.js";
import { Actions as n } from "../primitive/actions.js";
import { Calendar as r } from "../primitive/calendar.js";
import { DateField as ee } from "../primitive/date-field.js";
import { TimeFormatEnum as i } from "../types/date-time-format.js";
import { Popup as a } from "../primitive/popup.js";
import { transformSioDateFormatToDatePicker as o } from "../utils/transform-sio-date-format-to-date-picker.js";
import { useDateFnsLocale as s } from "../utils/use-date-fns-locale.js";
import { useDateTime as te } from "./use-date-time.js";
import { useMemo as c, useState as l } from "react";
import { jsx as u } from "react/jsx-runtime";
import { useMediaQuery as d } from "@systemeio/util";
import { enUS as f } from "date-fns/locale/en-US";
//#region src/date-picker/date-time-picker/date-time-picker.tsx
var p = "HH:mm", m = "dd/MM/yyyy", h = 15;
function g({ calendarClassName: g, clearable: _, description: v, disabled: y, disableApplyButton: b, error: x, filterDate: ne, filterTime: S, intlLocale: C, label: w, labelClassName: T, maxDate: E, minDate: D, onChange: O, onMonthChange: k, placeholder: A, required: j, size: M, timeClassName: N, timeIntervals: P, timezone: F, userDateFormat: I, userTimeFormat: L, value: R, wrapperButtonInputClassName: z }) {
	let { t: B } = t(), [V, H] = l(f);
	s(C, H);
	let { isMobile: U } = d(), [W, G] = l(!1), { appliedDate: K, applyDateTime: q, selectedDate: J, setSelectedDate: Y } = te({
		onChange: O,
		timezone: F,
		value: R
	}), X = P ?? h, Z = J ? !b?.(J) : !1, { dateFormat: re, timeFormat: ie } = c(() => I && L ? o(L, I) : {
		dateFormat: m,
		timeFormat: p
	}, [I, L]), ae = c(() => {
		if (K) return new Intl.DateTimeFormat(C, {
			day: "2-digit",
			hour: "numeric",
			hour12: L === i.hourMinuteAmPm || L === i.hourMinuteSecondAmPm,
			minute: "numeric",
			month: "long",
			second: L === i.hourMinuteSecond || L === i.hourMinuteSecondAmPm ? "numeric" : void 0,
			year: "numeric"
		}).format(K);
	}, [
		K,
		C,
		L
	]), oe = (e) => J && K && e.toDateString() === K.toDateString() && J.toDateString() !== K.toDateString() ? "datepicker-day--draft" : "", se = (e, t) => [J && K && e.getTime() === K.getTime() && J.getTime() !== K.getTime() ? "datepicker-time--draft" : "", t?.(e) ?? ""].filter(Boolean).join(" "), Q = () => {
		G(!1);
	}, ce = () => {
		J && (q(J), Q());
	}, $ = () => {
		q(null), Q();
	};
	return /* @__PURE__ */ u(a, {
		title: B("public_pages_purchase.date_picker.date_filter_title"),
		disabled: y,
		footerClassName: U ? "border-none" : "border-t border-gray-200",
		footer: /* @__PURE__ */ u(n, {
			className: "w-full gap-3",
			applyDisabled: y || !Z,
			clearDisabled: y,
			onApply: ce,
			onClear: $
		}),
		onClose: U ? Q : void 0,
		onOpenChange: (e) => {
			G(e), e || Y(K);
		},
		open: W,
		trigger: /* @__PURE__ */ u(ee, {
			clearable: _,
			description: v,
			disabled: y,
			error: x,
			focus: W,
			label: w,
			onClear: $,
			placeholder: A ?? B("public_pages_purchase.date_picker.date_and_time_placeholder"),
			required: j,
			size: M,
			value: ae,
			labelClassName: T,
			className: z
		}),
		triggerRender: /* @__PURE__ */ u("div", {
			"aria-label": w ? void 0 : A ?? B("public_pages_purchase.date_picker.date_and_time_placeholder"),
			className: "group/date-field-trigger w-full text-left",
			role: "button",
			tabIndex: 0
		}),
		children: /* @__PURE__ */ u(r, {
			calendarClassName: e(g),
			dateFormat: re,
			dayClassName: oe,
			filterDate: ne,
			filterTime: S,
			intlLocale: C,
			locale: V,
			maxDate: E,
			minDate: D,
			onChange: (e) => {
				e instanceof Date && Y(e);
			},
			onMonthChange: k,
			selected: J,
			showTimeSelect: !0,
			timeCaption: B("public_pages_purchase.date_picker.time"),
			timeClassName: (e) => se(e, N),
			timeFormat: ie,
			timeInputLabel: B("public_pages_purchase.date_picker.time"),
			timeIntervals: X
		})
	});
}
//#endregion
export { g as DateTimePicker };
